import { emptyObj } from '@beef/utils';
import { getLeavePhoneBlock } from "../selectors";
import { createMergedBlockSelector } from "../../selectors";
var getLeavePhoneData = createMergedBlockSelector(getLeavePhoneBlock);
export var getLeavePhoneBlockTitle = function getLeavePhoneBlockTitle(state) {
  return getLeavePhoneData(state).title || '';
};
export var getLeavePhoneBlockSubTitle = function getLeavePhoneBlockSubTitle(state) {
  return getLeavePhoneData(state).text;
};
export var getConnectionQuestionsBlock = function getConnectionQuestionsBlock(state) {
  return getLeavePhoneData(state).connectionQuestionsBlock || emptyObj;
};
export var getLeavePhoneBlockPhone = function getLeavePhoneBlockPhone(state) {
  return getConnectionQuestionsBlock(state).phoneNumbers;
};